import React from 'react';
import type { MacroKey } from '../types';
import proteinIcon from '../assets/macro-protein.png';
import carbsIcon from '../assets/macro-carbs.png';
import fatsIcon from '../assets/macro-fats.png';

const SRC: Record<MacroKey, string> = {
  p: proteinIcon,
  c: carbsIcon,
  f: fatsIcon,
};

/** Protein, carbs, and fats marks. Color comes from the parent `color`. */
export function MacroFoodIcon({ k, size = 14 }: { k: MacroKey; size?: number }) {
  return (
    <span
      aria-hidden
      style={{
        width: size,
        height: size,
        flex: 'none',
        display: 'inline-block',
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${SRC[k]})`,
        maskImage: `url(${SRC[k]})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  );
}
